import styled, { css } from 'styled-components'

import { mq, sizes } from '../../../theme'

export const Group = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  padding: 0;
  margin: 0;

  @media ${mq(sizes.desktop)} {
    justify-content: center;
    flex-direction: row;
  }
`

export const Legend = styled.legend`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`

export const Circle = styled.div`
  display: flex;
  position: absolute;
  left: 0.75rem;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  background: white;
  border-radius: 50%;
  border: 0.2rem solid ${({ theme }) => theme.colors.greenEmerald};
  box-shadow: inset 2px 2px 5px 1px rgba(0, 0, 0, 0.25);
  pointer-events: none;

  &:after {
    display: none;
    position: relative;
    width: 0.8rem;
    height: 0.8rem;
    transform: translateX(0.4rem) translateY(0.4rem);
    background: ${({ theme }) => theme.colors.pureBlack};
    border-radius: 50%;
    content: '';
  }
`

export const RadioWrapper = styled.div<{ checked: boolean; disabled: boolean }>`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16};

  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 3.5rem;
  width: auto;
  border-radius: calc(3.5rem / 2);
  outline: 0 none;
  border: 0.1rem solid
    ${({ theme, disabled }) =>
      disabled ? theme.colors.alto : theme.colors.greenEmerald};
  background: ${({ checked, theme }) =>
    checked ? theme.colors.greenEmerald : theme.colors.pureWhite};
  align-items: center;
  justify-content: center;
  user-select: none;

  ${({ checked }) =>
    checked &&
    css`
      ${Circle} {
        &:after {
          display: flex;
        }
      }
      ${Label} {
        color: ${({ theme }) => theme.colors.pureBlack};
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      ${Circle} {
        border: 0.2rem solid ${({ theme }) => theme.colors.alto};
      }
      ${Label} {
        &:hover {
          cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
        }
        color: ${({ theme }) => theme.colors.alto};
      }
    `}


  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }

  &:not(:first-of-type) {
    margin-top: 1.5rem;
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_condensed_14};

    height: 3.7rem;
    border-radius: calc(3.7rem / 2);

    &:not(:first-of-type) {
      margin-top: 0;
      margin-left: 3rem;
    }
  }
`
export const Radio = styled.input`
  display: none;
`

export const Label = styled.label`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 100%;
  padding-left: 3.5rem;
  padding-right: 1rem;
  color: ${({ theme }) => theme.colors.pureBlack};

  &:hover {
    cursor: pointer;
  }
`
